export const Asterisk = () => {
  return (
    <div className="flex justify-center my-20">
      <div className="relative w-48 h-48">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-[6px] h-48 bg-black left-1/2 -translate-x-1/2 origin-center"
            style={{
              transform: `translate(-50%) rotate(${i * 45}deg)`
            }}
          />
        ))}
      </div>
    </div>
  );
};